import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import RichTextEditor from "./richtext/RichTextEditor";
import useAxiosPrivate from "./useAxiosPrivate";
import useAuth from "./useAuth";

function EditList() {
    const [list, setList] = useState(null);
    const [items, setItems] = useState([]);
    const initialValue = useRef(null);

    const navigate = useNavigate();
    const params = useParams();
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosPrivate.get(`/lists/${params.listId}`, {headers: {Authorization: "Bearer " + auth.accessToken}});
                initialValue.current = response.data.items;
                setList(response.data);
                setItems(response.data.items);
            } catch (error) {
                console.error("Error fetching list:", error);
            }
        };
        fetchData();
    }, [axiosPrivate, auth.accessToken, params.listId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            name: list.name,
            items: items
        };
        try {
            await axiosPrivate.put(`/lists/${params.listId}`, payload, {headers: {Authorization: "Bearer " + auth.accessToken}});
            navigate("/lists");
        } catch(err) {
            console.log(err);
        }
    }

    if (!list) {
        return <div>Loading...</div>
    }

    return (
        <form onSubmit={handleSubmit}>
            <select
                id="name"
                name="name"
                value={list.name}
                onChange={(evt) => setList(curr => ({...curr, name: evt.target.value}))}
                required
                className="w-auto px-4 py-2 mb-4 text-sm text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            >
                <option value="">Choose Name</option>
                <option value="kiosks">Kiosks</option>
                <option value="branches">Branches</option>
                <option value="faqs">FAQs</option>
                <option value="loan_products">Loan Products</option>
                <option value="loan_requirements">Loan Requirements</option>
                <option value="corporates_farmers_traders">Corporates, Farmers, Traders</option>
            </select>
            <div className="pb-4">
                <RichTextEditor initialValue={initialValue.current} setValue={setItems} />
            </div>
            <button
                type="submit"
                className="float-right w-auto rounded-lg bg-indigo-500 hover:bg-indigo-600 px-4 py-2 text-sm text-white font-semibold shadow-md transition"
            >
                Submit
            </button>
        </form>
    );
}

export default EditList;